import React from "react";
import { ArrowRight, ShieldCheck, TrendingUp } from "lucide-react";
import rightImg from "../img/aaaservices/robo (2).jpg"; // apna image path yaha daalo
import "./HeroSection.css";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

export default function HeroSection() {
    const navigate = useNavigate();
  const stats = [
    { value: "18,420+", label: "Learners placed" },
    { value: "₹24.5 LPA", label: "Highest package" },
    { value: "112%", label: "Average hike" },
    { value: "640+", label: "Hiring partners" },
  ];

  return (
    <section className="iia-hero">
      <div className="iia-hero-container">
        {/* Left column */}
        <div className="iia-hero-left">
          <span className="iia-hero-badge">
            <ShieldCheck size={14} />
            Industry Certified Training
          </span>

          <h1 className="iia-hero-heading">
            Become the engineer that{" "}
            <span className="iia-hero-heading-accent">
              automates the factory floor.
            </span>
          </h1>

          <p className="iia-hero-subtext">
            Live PLC, SCADA, robotics and Industry 4.0 training built with
            plant engineers — with real hardware labs, graded projects, and a
            placement cell that has moved 18,420 learners into industry
            roles.
          </p>

          <div className="iia-hero-actions">
             <button
      className="iia-hero-cta-primary"
      onClick={() => navigate("/Secondactiveprograms")}
    >
      Explore Courses
      <ArrowRight size={16} />
    </button>
            {/* <button
  className="iia-hero-cta-secondary"
  onClick={() =>
    document.getElementById("placements")?.scrollIntoView({
      behavior: "smooth",
    })
  }
>
  <TrendingUp size={16} />
  View Placements
</button> */}
          </div>

          <div className="iia-hero-stats">
            {stats.map((s) => (
              <div className="iia-hero-stat" key={s.label}>
                <div className="iia-hero-stat-value">{s.value}</div>
                <div className="iia-hero-stat-label">{s.label}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Right column — Image */}
        <div className="iia-hero-right">
          <div className="iia-hero-image-wrap">
            <div className="iia-hero-glow-blue" />
            <div className="iia-hero-glow-orange" />

            <div className="iia-hero-image-frame">
              <img
                src={rightImg}
                alt="Automation training at IIA"
                className="iia-hero-image"
              />
            </div>

            <div className="iia-hero-floating-card">
              <span className="iia-hero-live-dot" />
              <div>
                <p className="iia-hero-floating-title">
                  Live now · PID Tuning in Real Plants
                </p>
                <p className="iia-hero-floating-subtitle">
                  186 learners · Dr. Kavita Rao
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}




// import React from "react";
// import mechanicalImg from "../Component/QuickBooks_training.png";
// import itImg from "../Component/QuickBooks_training.png";
// import automationImg from "../Component/QuickBooks_training.png";
// import roboticsImg from "../Component/QuickBooks_training.png";

// const OurOfferings = () => {
//   const offerings = [
//     {
//       image: mechanicalImg,
//       tag: "Core Engineering",
//       title: "Mechanical Engineering",
//       text: "Hands-on training in CAD/CAM, design, manufacturing processes and real industrial projects.",
//     },
//     {
//       image: itImg,
//       tag: "Technology",
//       title: "IT Services & Software",
//       text: "Full-stack development, cloud solutions and enterprise software built for scalable growth.",
//     },
//     {
//       image: automationImg,
//       tag: "Industry 4.0",
//       title: "Industrial Automation",
//       text: "PLC, SCADA and HMI training with live plant simulations and expert mentorship.",
//     },
//     {
//       image: roboticsImg,
//       tag: "Advanced Tech",
//       title: "Robotics & AI",
//       text: "Build and program industrial robots with AI-driven automation for smart manufacturing.",
//     },
//   ];

//   return (
//     <section className="offer-section">
//       <div className="offer-container">
//         <div className="offer-header">
//           <span className="offer-eyebrow">What We Offer</span>
//           <h2 className="offer-title">
//             <span className="offer-title-dark">Solutions Built For </span>
//             <span className="offer-title-accent">Tomorrow</span>
//           </h2>
//           <p className="offer-subtext">
//             From mechanical engineering to IT and automation — we deliver
//             industry-ready training and solutions across every domain.
//           </p>
//         </div>

//         <div className="offer-grid">
//           {offerings.map((item, index) => (
//             <div className="offer-card" key={index}>
//               <div className="offer-image-wrap">
//                 <img src={item.image} alt={item.title} loading="lazy" />
//                 <span className="offer-tag">{item.tag}</span>
//               </div>
//               <div className="offer-content">
//                 <h3 className="offer-card-title">{item.title}</h3>
//                 <p className="offer-card-text">{item.text}</p>
//                 <a href="#" className="offer-link">
//                   Learn more <span className="offer-arrow">→</span>
//                 </a>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>

//       <style>{`
//         .offer-section {
//           padding: 56px 20px;
//           background: #ffffff;
//         }

//         .offer-container {
//           max-width: 1200px;
//           margin: 0 auto;
//         }

//         .offer-header {
//           text-align: center;
//           max-width: 600px;
//           margin: 0 auto 40px;
//         }

//         .offer-eyebrow {
//           display: inline-block;
//           font-size: 11px;
//           font-weight: 700;
//           letter-spacing: 1.5px;
//           text-transform: uppercase;
//           color: #1d4ed8;
//           background: #eff6ff;
//           padding: 5px 16px;
//           border-radius: 20px;
//           margin-bottom: 14px;
//         }

//         .offer-title {
//           font-size: 28px;
//           font-weight: 800;
//           margin: 0 0 12px;
//           line-height: 1.25;
//           font-family: 'Segoe UI', Arial, sans-serif;
//         }

//         .offer-title-dark { color: #0f172a; }

//         .offer-title-accent {
//           background: linear-gradient(to right, #1d4ed8, #f7941d);
//           -webkit-background-clip: text;
//           background-clip: text;
//           color: transparent;
//         }

//         .offer-subtext {
//           font-size: 13.5px;
//           line-height: 1.65;
//           color: #64748b;
//           margin: 0;
//           font-family: 'Segoe UI', Arial, sans-serif;
//         }

//         .offer-grid {
//           display: grid;
//           grid-template-columns: repeat(4, 1fr);
//           gap: 24px;
//         }

//         .offer-card {
//           background: #ffffff;
//           border-radius: 16px;
//           overflow: hidden;
//           box-shadow: 0 8px 24px rgba(15, 23, 42, 0.1);
//           border: 1px solid #eef2f7;
//           transition: transform 0.3s ease, box-shadow 0.3s ease;
//         }

//         .offer-card:hover {
//           transform: translateY(-8px);
//           box-shadow: 0 20px 40px rgba(15, 23, 42, 0.16);
//         }

//         .offer-image-wrap {
//           position: relative;
//           width: 100%;
//           aspect-ratio: 4 / 3;
//           overflow: hidden;
//         }

//         .offer-image-wrap img {
//           width: 100%;
//           height: 100%;
//           object-fit: cover;
//           display: block;
//           transition: transform 0.4s ease;
//         }

//         .offer-card:hover .offer-image-wrap img {
//           transform: scale(1.06);
//         }

//         .offer-tag {
//           position: absolute;
//           top: 12px;
//           left: 12px;
//           background: rgba(255, 255, 255, 0.95);
//           color: #1d4ed8;
//           font-size: 10px;
//           font-weight: 700;
//           letter-spacing: 0.4px;
//           text-transform: uppercase;
//           padding: 5px 10px;
//           border-radius: 20px;
//           backdrop-filter: blur(4px);
//         }

//         .offer-content {
//           padding: 18px 18px 20px;
//         }

//         .offer-card-title {
//           font-size: 15.5px;
//           font-weight: 700;
//           color: #0f172a;
//           margin: 0 0 8px;
//           font-family: 'Segoe UI', Arial, sans-serif;
//         }

//         .offer-card-text {
//           font-size: 12.5px;
//           line-height: 1.6;
//           color: #64748b;
//           margin: 0 0 14px;
//           font-family: 'Segoe UI', Arial, sans-serif;
//         }

//         .offer-link {
//           display: inline-flex;
//           align-items: center;
//           gap: 4px;
//           font-size: 12.5px;
//           font-weight: 700;
//           color: #f7941d;
//           text-decoration: none;
//         }

//         .offer-arrow {
//           transition: transform 0.2s ease;
//         }

//         .offer-link:hover .offer-arrow {
//           transform: translateX(3px);
//         }

//         /* Tablet */
//         @media (max-width: 1024px) {
//           .offer-grid {
//             grid-template-columns: repeat(2, 1fr);
//           }
//         }

//         /* Mobile */
//         @media (max-width: 640px) {
//           .offer-section { padding: 40px 16px; }
//           .offer-title { font-size: 22px; }
//           .offer-subtext { font-size: 12.5px; }
//           .offer-grid {
//             grid-template-columns: 1fr;
//             gap: 18px;
//           }
//           .offer-card-title { font-size: 14.5px; }
//           .offer-card-text { font-size: 12px; }
//         }
//       `}</style>
//     </section>
//   );
// };

// export default OurOfferings;